<template>
  <el-row class="search_form_base">
    <searchInput
      v-for="(searchItem, index) in options"
      :key="index"
      :span="getSpan"
      :type="searchItem.type"
      :label="searchItem.label"
      v-model="searchForm[searchItem.property]"
      :placeholder="searchItem.placeholder"
      :options="searchItem.options"
      :clearable="searchItem.clearable"
      :startPlaceholder="searchItem.startPlaceholder"
      :endPlaceholder="searchItem.endPlaceholder"
      :defaultTime="searchItem.defaultTime"
      :valueFormat="searchItem.valueFormat"
      @input="(val) => inputChange(val, searchItem.property)"
      :ref="'searchInput' + index"
      @search="search"
    ></searchInput>
  </el-row>
</template>

<script>
import searchInput from "@/components/common/searchInput.vue";

export default {
  components: {
    searchInput,
  },
  props: {
    divide: {
      type: Number,
      default: 2,
    },
    options: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      searchForm: {},
    };
  },
  computed: {
    getSpan() {
      return 24 / this.divide;
    },
  },
  methods: {
    getQuerys() {
      let result = [];
      this.options.forEach((searchItem) => {
        let operation = searchItem.operation || "EQUAL";
        if (searchItem.type == "datetimerange") {
          operation = "BETWEEN";
        }
        let value = this.searchForm[searchItem.property];
        if (value && (value.constructor() != "[]" || value.length != 0)) {
          result.push({
            property: searchItem.property,
            operation: operation,
            value: this.searchForm[searchItem.property],
            relation: "AND",
            group: "searchForm",
          });
        }
      });
      return result;
    },
    inputChange(val, property) {
      this.searchForm[property] = val;
    },
    reset() {
      this.$set(this, "searchForm", {});
      for(let i = 0 ; i < this.options.length ; i ++){
          this.$refs["searchInput"+i][0].reset();
      }
    },
    search(){
        this.$emit("search");
    }
  },
};
</script>

<style lang="scss" scoped>
.search_form_base {
  width: 100%;
}
</style>